import React from 'react';

const ListGroupRowTitleValue = ({ heading, subheading, value, valueClass }) => {
    return (
        <li className="list-group-item">
        <div className="widget-content p-0">
            <div className="widget-content-outer">
                <div className="widget-content-wrapper">
                    <div className="widget-content-left">
                        <div className="widget-heading">{heading}</div>
                        <div className="widget-subheading">{subheading}</div>
                    </div>
                    <div className="widget-content-right">
                        <div className={`badge badge-pill badge-${valueClass}`} style={{textTransform: 'none'}}>{value}</div>
                        {/* <div className={`widget-numbers ${valueClass}`}>{value}</div> */}
                    </div>
                </div>
            </div>
        </div>
    </li>
    );
};

export default ListGroupRowTitleValue;